"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtmReporter = void 0;
function gtmReporter() {
    const reporter = {
        addMetadata: function (metadata) {
            var _a;
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(metadata);
        },
        trackEvent: function (event) {
            reporter.addMetadata({
                ...event.metadata,
                ...event.tags,
                ...event.metrics,
                event: event.message,
                level: event.level,
            });
        },
        addBreadcrumb: function (breadcrumb) {
            reporter.addMetadata({
                ...breadcrumb.metadata,
                event: breadcrumb.message,
            });
        },
        setUser: function (user) {
            if (user) {
                reporter.addMetadata({ user });
            }
        },
        setRouteName: function (routeName) {
            reporter.addMetadata({ routeName });
        },
        setPageName: function (pageName) {
            reporter.addMetadata({ pageName });
        },
        reportError: function () { },
        recordSession: function () { },
        recordSessionStop: function () { },
    };
    return reporter;
}
exports.gtmReporter = gtmReporter;
//# sourceMappingURL=gtmReporter.js.map